import axios from 'axios';
export default {
  props: {
    moduleCollapsed: {
      type: Boolean,
      default: false
    },
    productId: {
      required: true
    },
    locale: 'de'
  },
  data(){
    return {
      loaded: false
    }
  },
  methods: {
    scrollToElement(jqEl){
      $('html, body').animate({ scrollTop: (jqEl.offset().top-70)})
    },
    stepBack(){
      this.$emit('step-back', this.currentStep)
    },
    stepBackTo(prevStep){
      this.$emit('step-back', prevStep)
    },
    sectionClicked(){
      this.$emit('section-clicked', this.currentStep)
    },
    apiUrl(action){
      return `${process.env.BASE_URL}/api/booking/${this.productId}/${action}`
    },
    addErrorForElement(id){
      const section = $(`.booking-element#${id}`)
      this.scrollToElement(section)
      this.resetElementErrors()
      section.addClass('booking-error')
    },
    showGlobalErrorMessage(text){
      $("#booking-error-overlay").show()
      $("#booking-error-overlay .error-content").html(text)
    },
    removeErrorForElement(id){
      const section = $(`.booking-element#${id}`)
      section.removeClass('booking-error')
    },
    resetElementErrors(){
      $('.booking-element.booking-error').removeClass('booking-error')
    },
    gTrack(evt, label = window.location.href, details = {}){
      try{
        gtag('event', evt, {'event_category': 'Booking', 'event_label': label})
        console.log(evt, {'event_category': 'Booking', 'event_label': label})
      }catch {
        console.log("GTAG tracking failed")
        console.log(evt, {'event_category': 'Booking', 'event_label': label})
      }
      
      // disabled . is not used at all
      //axios.post(this.apiUrl('write_ga_event'), {name: evt, category: 'Booking', label: label, details: details})
    },
    gTrackProceed(){
      this.gTrack(`${this.currentStep}:clickProceed`)
    }
  }
}